<template>
<!-- 客源定价 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <!-- 顶部搜索框 -->
    <el-form class="findform">
      <el-form-item style="display:flex;width:30%" label="所属城市：">
        <el-cascader v-model="chengshi" placeholder="请选择城市" :options="options" style="width:90%"
         filterable clearable @change="handleChange" ref="cityAll"/>
      </el-form-item>
    </el-form>
  </div>
  <!-- 列表 -->
  <div class="main_container">
    <div style="width: 98%;display: flex;justify-content: space-between;text-align: center;margin: 0 auto;">
      <p>当前配置：{{ nameOfProvince?nameOfProvince:'全国' }} {{ cityName }} {{ countyName }}</p>
      <p style="float: right;">重要提示：本功能用于客源变现每个需求默认初始价格。</p>
    </div>
    <div class="grid-container">
      <div v-for="(item, index) in inputList" :key="'item-' + item.cluetypeid + '-' + index" class="grid-item">
        <label :for="item.cluetypeid" class="labelClass">{{ item.cluetypename }}</label>
        <el-input :id="item.cluetypeid" v-model="item.price" maxlength="5" :style="{ marginLeft: '-2px' }"
        onkeyup="value=value.replace(/[^\d]/g,'');"/> <span style="line-height: 40px;margin-left: 10px;">元</span>
      </div>
    </div>
    <!-- 操作按钮 -->
     <!-- 权限: 城市合伙人=1 判断 scid 大于 0 隐藏按钮 -->
    <div style="width: 100%; text-align: center;margin: 10px 0 20px 0;" v-show="iscityadmin == 0 || scid < 0">
      <el-button @click="resetForm()">重置</el-button>
      <el-button type="danger" @click="addgoodcolunm()">保存</el-button>
    </div>
  </div>
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { provincegetcountys } from '../../api/newOss';
import { pricegetlist, priceset } from "../../api/comment";
export default {
  name: "customprice",
  mixins: [alertTrends],
  data() {
    return {
      chengshi: [0], // 所在城市
      options: [],
      provinceId: 0, // 省
      cityId: 0, // 市
      countyId: 0, // 区县
      nameOfProvince: '', // 省名称
      cityName: '', // 市名称
      countyName: '', // 区县名称
      
      inputList: [
        // { cluetypeid: 1, cluetypename: '姓名姓名姓', price: '12' },
        // { cluetypeid: 2, cluetypename: '姓的名', price: '22' },
        // { cluetypeid: 3, cluetypename: '姓名姓名姓', price: '336' },
        // { cluetypeid: 4, cluetypename: '姓名', price: '44' },
        // { cluetypeid: 5, cluetypename: '姓的名', price: '557' },
        // { cluetypeid: 6, cluetypename: '姓名姓名姓', price: '7787' },
      ],
      
      isadmin: localStorage.isadmin, // 是否是超级管理员 0=否 1=是
      isplatformadmin: localStorage.isplatformadmin, // 是否是平台(全国)管理员 0=否 1=是
      iscityadmin: localStorage.iscityadmin, // 是否是城市管理员(城市分公司) 0=否 1=是
      scid: localStorage.scid, // 区县id

    };
  },
  methods: {
    init(){
      var obj = {
        pid: this.provinceId, // 省份ID
        cid: this.cityId, // 城市ID
        scid: this.countyId, // 区县ID 目前未开放区县配置 传0
      }
      pricegetlist(obj).then(data=>{
        if(data.resultCode == 1){
          this.inputList = data.resultObj;
        }else{
          this.inputList = [];
        }
      })
    },
    // 重置
    resetForm(){
      this.init();
    },
    // 保存
    addgoodcolunm(){
      if(this.provinceId == 0){
        this.showAlert('请选择省');
        return false;
      }
      this.$swal({
        type:'warning',
        text: '是否保存？',
        showCancelButton:true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then(res => {
        if(res.value){
          var obj = {
            pid: this.provinceId, // 省份ID
            cid: this.cityId, // 城市ID
            scid: this.countyId, // 区县ID 目前未开放区县配置 传0
            cluetypes: this.inputList,
          }
          priceset(obj).then(data=>{
            if(data.resultCode == 1){
              this.showAlert('操作成功', 'success');
              this.init();
            }
          })
        }
      })
    },
    // 请选择省市区/县
    handleChange(val) {
      this.provinceId = val[0]; // 省
      this.cityId = val[1]; // 市
      this.countyId = val[2]; // 区县
      let labels = this.$refs['cityAll'].getCheckedNodes()[0].pathLabels;
      this.nameOfProvince = labels[0];
      this.cityName = labels[1];
      this.countyName = labels[2];
      this.init();
    },
    // 查找省市区/县
    getprovince() {
      var loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          if (item.citys && item.citys.length > 0) {
            item.citys.forEach(city => {
              const allCityOption = { value: 0, label: "全市" };
              let cityObj;
              if (city.countys && city.countys.length > 0) {
                cityObj = {
                  value: city.cid, label: city.cname,
                  children: [allCityOption].concat(city.countys.map(zone => ({
                    value: zone.scid, label: zone.scname
                  })))
                };
              } else {
                cityObj = { value: city.cid, label: city.cname, children: [allCityOption] };
              }
              province.children.push(cityObj);
            });
          } else {delete province.children;}
          provinceOptions.push(province);
        });
        this.options = provinceOptions;
        if(this.isadmin == 1 || this.isplatformadmin == 1){
          this.options.unshift({value: 0, label: "全国"});
        }
      })
    },
  },
  mounted(){
    this.getprovince();
    this.init();
  },
};
</script>
<style scoped>
.labelClass{
  width: 150px;
  height: auto;
  background: #909399;
  color: #fff;
  display: block;
  text-align: center;
  line-height: 40px;
  z-index: 1;
  border-radius: 4px 0 0 4px;
}
.grid-container {
  width: 98%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 分为4列，每列等宽 */
  gap: 20px; /* 项目之间的间隔 */
  padding-bottom: 20px;
}

.grid-item {
  /* 可根据需要调整盒子样式 */
  display: flex;
  width: 80%;
}
</style>


// WEBPACK FOOTER //
// customprice.vue?3c231fb2